document.addEventListener('DOMContentLoaded', () => {
  /* Demo */
  demoBackLink();
  document.querySelectorAll('.js-demo-form').forEach(form => {
    demoUtmFields(form);
    demoSourceOther(form);
    demoHoneypot(form);
  });
});

const DEMO_UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

/**
 * Points the back link at the page the visitor came from, so hover, copy and
 * new-tab clicks all show the real destination. Plain clicks use history.back()
 * to keep the previous page's scroll position. Without a referrer (direct visit,
 * new tab) the link keeps its fallback URL.
 */
function demoBackLink() {
  const stripUrl = url => url.split('#')[0].split('?')[0];
  const { referrer } = document;

  if (!referrer || stripUrl(referrer) === stripUrl(window.location.href)) {
    return;
  }

  document.querySelectorAll('.js-demo-back').forEach(link => {
    link.href = referrer;

    link.addEventListener('click', event => {
      const isPlainClick = event.button === 0
        && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

      if (isPlainClick && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  });
}

/**
 * Copies the UTM parameters of the current URL into hidden fields, so they
 * reach Pardot with the submission.
 */
function demoUtmFields(form) {
  const params = new URLSearchParams(window.location.search);

  DEMO_UTM_KEYS.forEach(name => {
    const value = params.get(name);
    if (!value) {
      return;
    }

    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value.slice(0, 255);
  });
}

/**
 * Shows the free-text "Where did you hear about us?" field only when "Other"
 * is selected. The field is disabled while hidden, so it is not submitted.
 */
function demoSourceOther(form) {
  const source = form.querySelector('.js-demo-source');
  const otherWrap = form.querySelector('.js-demo-source-other');
  const otherInput = otherWrap ? otherWrap.querySelector('input') : null;

  if (!source || !otherWrap || !otherInput) {
    return;
  }

  const sync = () => {
    const isOther = source.value === 'Other';

    otherWrap.hidden = !isOther;
    otherInput.disabled = !isOther;

    if (!isOther) {
      otherInput.value = '';
    }
  };

  source.addEventListener('change', sync);
  sync();
}

/**
 * Blocks submissions where the hidden honeypot field was filled in (bots),
 * and leaves the empty honeypot out of legitimate Pardot submissions.
 */
function demoHoneypot(form) {
  const field = form.querySelector('.js-demo-honeypot');
  if (!field) {
    return;
  }

  form.addEventListener('submit', event => {
    if (field.value.trim() !== '') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    field.disabled = true;
  }, true);

  // Re-enable after a back/forward cache restore, so the check runs again.
  window.addEventListener('pageshow', () => {
    field.disabled = false;
  });
}
